import React from 'react';

import Helmet from 'common/helmets/Helmet';

const Title = 'Pallyy Case Study | Canny';
const Description = 'How Canny helps Pallyy save time and shape their roadmap';
const Image = 'https://canny.io/images/c4433b983deeb70c0a43cbe5bb475b6e.jpg';

const PallyyLandingHelmet = ({ ...props }) => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/case-studies/pallyy' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
      {...props}
    />
  );
};

export default PallyyLandingHelmet;
